import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { environment } from '@pt/environment';
import { Observable, share } from 'rxjs';
import { excludeEmptyIds, getQueryParams } from '@hglobal/common';

import {
  ChangeRequestStatusReq,
  ChangeRequestStatusRes,
  GetRequestDetailsEncryptedDataReq,
  GetRequestDetailsEncryptedDataRes,
  GetRequestDetailsReq,
  GetRequestDetailsRes,
  GetRequestsReq,
  GetRequestsRes, GetUsersByIdsReq, GetUsersByIdsRes,
} from '../models';
import { UserFinancialRequestsService } from './user-financial-requests-api.service';

@Injectable()
export class AdminFinancialRequestsService extends UserFinancialRequestsService {
  readonly #httpClient = inject(HttpClient);

  override getRequests(
    params: GetRequestsReq,
    isAssignedToMe: boolean,
  ): Observable<GetRequestsRes> {
    return this.#httpClient.get<GetRequestsRes>(
      `${environment.apiHost}support/admin/financial-requests/${isAssignedToMe ? 'assigned/' : ''}`,
      {
        params: getQueryParams(params),
      },
    ).pipe(share());
  }

  override getRequestDetails(params: GetRequestDetailsReq): Observable<GetRequestDetailsRes> {
    return this.#httpClient.get<GetRequestDetailsRes>(
      `${environment.apiHost}support/admin/financial-requests/${params.requestId}/`,
    ).pipe(share());
  }

  override getRequestDetailsEncryptedData(
    params: GetRequestDetailsEncryptedDataReq,
  ): Observable<GetRequestDetailsEncryptedDataRes> {
    return this.#httpClient.get<GetRequestDetailsEncryptedDataRes>(
      `${environment.apiHost}financial-requests/admin/${params.requestIdHash}/`,
    ).pipe(share());
  }

  override changeRequestStatus(params: ChangeRequestStatusReq): Observable<ChangeRequestStatusRes> {
    const payload = { status: params.status };

    return this.#httpClient.put<ChangeRequestStatusRes>(
      `${environment.apiHost}support/admin/financial-requests/${params.requestId}/`,
      excludeEmptyIds(payload),
    ).pipe(share());
  }

  override getUsersByIds(params: GetUsersByIdsReq): Observable<GetUsersByIdsRes> {
    return this.#httpClient.get<GetUsersByIdsRes>(
      `${environment.apiHost}user/admin/users-search/`, { params: getQueryParams(params) },
    ).pipe(share());
  }
}
